import { Company } from "../../entities/Company";
import { CompanyService } from "../../services/CompanyService";
import { NotificationService } from "../../services/NotificationService";

export class EditCompanyCtrl {
    $scope: any;
    entity: Company;

    modalInstance: angular.ui.bootstrap.IModalServiceInstance;
    public static $inject = ['$scope', '$uibModalInstance', 'CompanyService', 'NotificationService', 'company'];
    constructor($scope: any, $modalInstance: angular.ui.bootstrap.IModalServiceInstance, public companyService: CompanyService, public notifyService: NotificationService, company: Company) {
        this.$scope = $scope;
        this.modalInstance = $modalInstance;
        this.entity = company;
        $scope.vm = this;
    }
    ok() {
        if (this.entity.name == null || this.entity.name.length == 0) {
            this.notifyService.notifyError(("Name is required"));
            return;
        }
        //allowRefreshTokens
        this.modalInstance.close(true);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
